import React from 'react';
import PropTypes from 'prop-types';

import { HeaderLoggedIn } from '@xingternal/platform-layout-header-logged-in';
import { LegalFooter } from '@xingternal/platform-layout-legal-footer';
import { ViewWrapper } from '@xingternal/platform-layout-view-wrapper';

import styles from './ZenViewGridLess.css';

const ZenViewGridLess = ({
  armstrongV1,
  children,
  className,
  contentClassName,
  helpLink,
  testId,
  withSubNav,
}) => {
  return (
    <ViewWrapper
      className={className}
      contentClassName={contentClassName}
      testId={testId}
      Header={withSubNav ? undefined : <HeaderLoggedIn helpLink={helpLink} />}
      Footer={
        armstrongV1 ? undefined : (
          <footer className={styles.footer}>
            <LegalFooter isInlineAlways withCopyright />
          </footer>
        )
      }
    >
      {children}
    </ViewWrapper>
  );
};
ZenViewGridLess.propTypes = {
  armstrongV1: PropTypes.bool.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  helpLink: PropTypes.string,
  testId: PropTypes.string,
  withSubNav: PropTypes.bool,
};

export { ZenViewGridLess };
